import { RefObject, Fragment } from 'react';

import { useChatbotContext } from '../../_context/ChatbotContext';
import ResetSessionButton from './ResetSessionButton';
import AiChatBotContainer from './AiChatBotContainer';
import LandingQuestion from './LandingQuestion';
import BotBubble from './BotBubble';
import { useRecoilState } from 'recoil';
import { initialRequestState } from '@/store/atom';
import { Message } from '@/types/discover';

interface AiChatbotMessagesProps {
  scrollDivRef: RefObject<HTMLDivElement>;
  messagesEndRef: RefObject<HTMLDivElement>;
}

const AiChatbotMessages = ({ scrollDivRef, messagesEndRef }: AiChatbotMessagesProps) => {
  const { messages } = useChatbotContext();

  return (
    <article
      className="flex flex-col overflow-auto border-b-[1px] border-gr-100 pb-[10px] pl-[16px] pr-[12px] pt-[16px]"
      ref={scrollDivRef}
    >
      {messages.map((message, idx) => (
        <Fragment key={idx}>
          {message.errorCode === 500 ? (
            <ResetSessionButton idx={idx} />
          ) : (
            <MessageItem message={message} idx={idx} />
          )}
        </Fragment>
      ))}
      <div ref={messagesEndRef} />
      <LoadingSection />
    </article>
  );
};

export default AiChatbotMessages;

export const MessageItem = ({
  message,
  idx,
  isDashboard = false,
}: {
  message: Message;
  idx: number;
  isDashboard?: boolean;
}) => {
  const { messages } = useChatbotContext();
  const isInitialRequest =
    (message.id === 0 && idx === messages.length - 1) ||
    (messages[messages.length - 2]?.action === 'INFO_GATHER' && idx === messages.length - 1);

  return (
    <div className="flex flex-col">
      <AiChatBotContainer data={message} isDashboard={isDashboard} />
      {isInitialRequest && <LandingQuestion />}
    </div>
  );
};

export const LoadingSection = ({ isDashboard = false }: { isDashboard?: boolean }) => {
  const { isLoading, isThinking } = useChatbotContext();
  const [initialRequest] = useRecoilState(initialRequestState);

  return (
    <section className="flex flex-col">
      {isThinking && (
        <BotBubble isDashboard={isDashboard} type={!initialRequest ? 'thinking' : 'loading'} />
      )}
      {isLoading && <BotBubble isDashboard={isDashboard} type="loading" />}
    </section>
  );
};
